// Chakra Imports
import {
  Avatar,
  Button,
  Flex,
  Icon,
  Image,
  Link,
  Menu,
  MenuButton,
  MenuItem,
  MenuList,
  Text,
  useColorModeValue,
} from "@chakra-ui/react";
// Custom Components
import { ItemContent } from "components/menu/ItemContent";
import { SearchBar } from "components/navbar/searchBar/SearchBar";
import { SidebarResponsive } from "components/sidebar/Sidebar";
import PropTypes from "prop-types";
import React, { useEffect, useState } from "react";
// Assets
import navImage from "assets/img/layout/Navbar.png";
import { MdNotificationsNone, MdInfoOutline } from "react-icons/md";
import { FaEthereum } from "react-icons/fa";
import routes from "routes.js";
import { ThemeEditor } from "./ThemeEditor";
import { getCurrentUser, getToken, logout } from "Api/apiService";
import { useHistory } from "react-router-dom";

const normalizeValue = (value) => String(value || "").trim();

const getUserDisplayName = () => {
  const storedName =
    sessionStorage.getItem("userName") || localStorage.getItem("userName");
  const storedEmail =
    sessionStorage.getItem("userEmail") || localStorage.getItem("userEmail");
  const baseValue = normalizeValue(storedName || storedEmail);
  if (!baseValue) {
    return "User";
  }
  const localPart = baseValue.split("@")[0];
  const segments = localPart.split(/[._-]+/).filter(Boolean);
  if (segments.length === 0) {
    return localPart;
  }
  return segments
    .map((segment) =>
      segment ? `${segment[0].toUpperCase()}${segment.slice(1)}` : segment
    )
    .join(" ");
};

const getInitials = (value) => {
  const cleaned = normalizeValue(value);
  if (!cleaned) {
    return "U";
  }
  const parts = cleaned.split(/\s+/).filter(Boolean);
  if (parts.length >= 2) {
    return `${parts[0][0]}${parts[1][0]}`.toUpperCase();
  }
  return cleaned.slice(0, 2).toUpperCase();
};

export default function HeaderLinks(props) {
  const history = useHistory();

  const { secondary } = props;
  // Chakra Color Mode
  const navbarIcon = useColorModeValue("gray.400", "white");
  let menuBg = useColorModeValue("white", "navy.800");
  const textColor = useColorModeValue("secondaryGray.900", "white");
  const textColorBrand = useColorModeValue("brand.700", "brand.400");
  const ethColor = useColorModeValue("gray.700", "white");
  const borderColor = useColorModeValue("#E6ECFA", "rgba(135, 140, 189, 0.3)");
  const ethBg = useColorModeValue("secondaryGray.300", "navy.900");
  const ethBox = useColorModeValue("white", "navy.800");
  const shadow = useColorModeValue(
    "14px 17px 40px 4px rgba(112, 144, 176, 0.18)",
    "14px 17px 40px 4px rgba(112, 144, 176, 0.06)"
  );
  const borderButton = useColorModeValue("secondaryGray.500", "whiteAlpha.200");
  const [userDisplayName, setUserDisplayName] = useState(
    getUserDisplayName()
  );
  const userInitials = getInitials(userDisplayName);

  useEffect(() => {
    const storedName =
      sessionStorage.getItem("userName") || localStorage.getItem("userName");
    if (storedName || !getToken()) {
      return;
    }
    let isActive = true;
    getCurrentUser()
      .then((response) => {
        const { username, email } = response.data || {};
        if (username) {
          sessionStorage.setItem("userName", username);
        }
        if (email) {
          sessionStorage.setItem("userEmail", email);
        }
        if (isActive) {
          setUserDisplayName(getUserDisplayName());
        }
      })
      .catch((error) => {
        console.error("Error fetching current user:", error);
      });
    return () => {
      isActive = false;
    };
  }, []);

  const handleLogout = () => {
    logout(history);
  };
  return (
    <Flex
      w={{ sm: "100%", md: "auto" }}
      alignItems="center"
      flexDirection="row"
      bg={menuBg}
      flexWrap={secondary ? { base: "wrap", md: "nowrap" } : "unset"}
      p="10px"
      borderRadius="30px"
      boxShadow={shadow}
    >
      <SearchBar
        mb={secondary ? { base: "10px", md: "unset" } : "unset"}
        me="10px"
        borderRadius="30px"
      />

      <SidebarResponsive routes={routes} />

      <Menu>
        <MenuButton p="0px">
          <Avatar
            _hover={{ cursor: "pointer" }}
            color="white"
            name={userInitials}
            bg="#11047A"
            size="sm"
            w="40px"
            h="40px"
          />
        </MenuButton>
        <MenuList
          boxShadow={shadow}
          p="0px"
          mt="10px"
          borderRadius="20px"
          bg={menuBg}
          border="none"
        >
          <Flex w="100%" mb="0px">
            <Text
              ps="20px"
              pt="16px"
              pb="10px"
              w="100%"
              borderBottom="1px solid"
              borderColor={borderColor}
              fontSize="sm"
              fontWeight="700"
              color={textColor}
            >
              Hey, {userDisplayName}
            </Text>
          </Flex>
          <Flex flexDirection="column" p="10px">
            <MenuItem
              _hover={{ bg: "none" }}
              _focus={{ bg: "none" }}
              color="red.400"
              borderRadius="8px"
              px="14px"
              onClick={handleLogout}
            >
              <Text fontSize="sm">Log out</Text>
            </MenuItem>
          </Flex>
        </MenuList>
      </Menu>
    </Flex>
  );
}

HeaderLinks.propTypes = {
  variant: PropTypes.string,
  fixed: PropTypes.bool,
  secondary: PropTypes.bool,
  onOpen: PropTypes.func,
};
